import lykkeClient from "@/api/clients/axios";
import type {
  ProductAvailabilitiesResponse,
  ProductDetailsResponse,
} from "@/types/api/marketplace-product";

export const fetchMarketplaceProductDetails = async (
  slug: string
): Promise<ProductDetailsResponse> => {
  const { data } = await lykkeClient.get<ProductDetailsResponse>(
    `/v2/experiences/product/${slug}/details`
  );

  return data;
};

export const fetchMarketplaceProductAvailabilities = async (
  productUid: string,
  start: string,
  end: string
): Promise<ProductAvailabilitiesResponse> => {
  const { data } = await lykkeClient.get<ProductAvailabilitiesResponse>(
    `/v2/experiences/product/${productUid}/availabilities`,
    {
      params: {
        start,
        end,
      },
    }
  );

  return data;
};
